import React, { memo } from 'react';
import ImageLightboxItem from './ImageLightboxItem';
import LightboxProvider from './LightboxProvider';

const LightboxLoadable = memo(
  ({ images, name, children }) => {
    return (
      <LightboxProvider>
        {images &&
          !!images.length &&
          images.map((item, key) => (
            <ImageLightboxItem
              key={key.toString()}
              image={item}
              caption={item.sub}
              group={name}
            >
              {item.children}
            </ImageLightboxItem>
          ))}
        {children}
      </LightboxProvider>
    );
  },
  (prevProps, nextProps) =>
    prevProps.images === nextProps.images ||
    prevProps.children === nextProps.children
);

export default LightboxLoadable;
